import React from 'react';
import { Hero } from '../components/home/Hero';
import { HowItWorksTease } from '../components/home/HowItWorksTease';
import { ImpactCounters } from '../components/home/ImpactCounters';
import { FounderStory } from '../components/home/FounderStory';
import { BecomePartner } from '../components/home/BecomePartner';
import { Testimonial } from '../components/home/Testimonial';
import { DonationTiers } from '../components/home/DonationTiers';
import { Newsletter } from '../components/home/Newsletter';
export function HomePage() {
  return <>
      <Hero data-id="element-549" />
      <HowItWorksTease data-id="element-550" />
      <ImpactCounters data-id="element-551" />
      <FounderStory data-id="element-552" />
      <BecomePartner data-id="element-553" />
      <Testimonial data-id="element-554" />
      <DonationTiers data-id="element-555" />
      <Newsletter data-id="element-556" />
    </>;
}